module.exports = __webpack_public_path__ + "static/media/29.63627b81.png";